(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COLS = ['coffee', 'energy', 'nootropic'];

    function initSection(sectionEl) {
      var tabs = sectionEl.querySelectorAll('.c-comparison-table__tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var col = tab.getAttribute('data-col');
          COLS.forEach(function (c) {
            sectionEl.classList.remove('is-tab-' + c);
          });
          sectionEl.classList.add('is-tab-' + col);
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
        });
      });
    }

    document.querySelectorAll('.c-comparison-table').forEach(initSection);

    document.addEventListener('shopify:section:load', function (evt) {
      var el = evt.target;
      if (el && el.classList.contains('c-comparison-table')) initSection(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-faq-v2"] && !Shopify.designMode) return;
  try {
    
  // "One open at a time" for `c-faq-v2`. Without JS every row still opens
  // and closes on its own (native <details>).
  (() => {
    const init = (root) => {
      if (!root || !root.hasAttribute('data-fq2-single') || root.dataset.fq2Ready === '1') return;
      root.dataset.fq2Ready = '1';
      const items = [...root.querySelectorAll('.c-fq2__item')];
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    };

    const boot = () => document.querySelectorAll('[data-section-type="c-faq-v2"]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();

    document.addEventListener('shopify:section:load', (event) => {
      const t = event.target && event.target.querySelector('[data-section-type="c-faq-v2"]');
      if (t) init(t);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mag-compare"] && !Shopify.designMode) return;
  try {
    
  // Muestra Magnesium+ contra una marca a la vez por debajo de 978px, que es lo
  // que hace el frame mobile. Las celdas ocultas llevan `hidden`, así que sin
  // JS la tabla se ve entera y scrollea: no se esconde información.
  (function () {
    var MOBILE = '(max-width: 977.98px)';

    function init(root) {
      var sw = root.querySelector('[data-mag-switch]');
      var grid = root.querySelector('.c-mag-cmp__grid');
      if (!sw || !grid || root.dataset.magCmpReady === '1') return;
      root.dataset.magCmpReady = '1';

      var dots = Array.prototype.slice.call(sw.querySelectorAll('[data-mag-dot]'));
      var nameEl = sw.querySelector('[data-mag-comp-name]');
      var btn = sw.querySelector('[data-mag-next-comp]');
      var heads = Array.prototype.slice.call(
        root.querySelectorAll('.c-mag-cmp__row--head [data-mag-comp]')
      );
      var names = heads.map(function (h) { return (h.textContent || '').trim(); });
      var total = names.length;
      if (!total) return;

      var active = 0;
      var mq = window.matchMedia(MOBILE);

      function paint() {
        var on = mq.matches;
        grid.setAttribute('data-mag-switched', on ? 'true' : 'false');
        root.querySelectorAll('[data-mag-comp]').forEach(function (cell) {
          var i = Number(cell.getAttribute('data-mag-comp'));
          if (on && i !== active) cell.setAttribute('hidden', '');
          else cell.removeAttribute('hidden');
        });
        dots.forEach(function (d, i) {
          d.setAttribute('data-active', i === active ? 'true' : 'false');
        });
        if (nameEl) nameEl.textContent = names[active] || '';
        if (btn) {
          btn.setAttribute('aria-label', 'Comparing against ' + (names[active] || '') + '. Show the next one.');
        }
      }

      if (btn) {
        btn.addEventListener('click', function () {
          active = (active + 1) % total;
          paint();
        });
      }

      if (mq.addEventListener) mq.addEventListener('change', paint);
      else if (mq.addListener) mq.addListener(paint);

      paint();
    }

    function boot() {
      document.querySelectorAll('[data-section-type="c-mag-compare"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-section-type="c-mag-compare"]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mag-faq"] && !Shopify.designMode) return;
  try {
    
  // One row open at a time, with the panel height animated from a measured
  // value. Scoped by data attribute and re-run on section load so the theme
  // editor keeps working after a re-render.
  (function () {
    function init(root) {
      var items = root.querySelectorAll('[data-mag-faq-item]');
      if (!items.length || root.dataset.magFaqReady === '1') return;
      root.dataset.magFaqReady = '1';

      function panelOf(item) {
        return item.querySelector('.c-mag-faq__panel');
      }

      function close(item) {
        var panel = panelOf(item);
        if (!panel) return;
        panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
        window.setTimeout(function () {
          item.open = false;
        }, 300);
      }

      items.forEach(function (item) {
        var panel = panelOf(item);
        if (panel) panel.style.height = item.open ? 'auto' : '0px';

        item.querySelector('summary').addEventListener('click', function (event) {
          event.preventDefault();
          var opening = !item.open;

          items.forEach(function (other) {
            if (other !== item && other.open) close(other);
          });

          if (!opening) {
            close(item);
            return;
          }

          item.open = true;
          var p = panelOf(item);
          if (!p) return;
          p.style.height = '0px';
          requestAnimationFrame(function () {
            p.style.height = p.scrollHeight + 'px';
          });
          // Back to auto once the transition is done, so a resize or a longer
          // answer is not clipped by the pixel height we just set.
          window.setTimeout(function () {
            if (item.open) p.style.height = 'auto';
          }, 340);
        });
      });
    }

    function boot() {
      document.querySelectorAll('[data-section-type="c-mag-faq"]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-section-type="c-mag-faq"]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mag-hero"] && !Shopify.designMode) return;
  try {
    
  // Galería de la tarjeta del hero.
  //
  // El bloque javascript de las secciones se empaqueta en UN archivo que carga
  // en todas las páginas, así que esto busca sus propias secciones en vez de
  // dar por hecho que es dueño del documento. El `shopify:section:load` es para
  // sobrevivir a que el editor cambie la sección en caliente.
  //
  // El carril ya arrastra solo con CSS scroll-snap: esto sólo suma las
  // miniaturas y mantiene sincronizado cuál está marcada.
  (() => {
    const SELECTOR = '[data-section-type="c-mag-hero"]';

    function init(root) {
      if (!root || root.dataset.magHeroReady === '1') return;
      root.dataset.magHeroReady = '1';

      const frame = root.querySelector('[data-mag-hero-frame]');
      const thumbs = [...root.querySelectorAll('[data-mag-hero-thumb]')];
      if (!frame || !thumbs.length) return;

      let index = 0;

      const mark = () => {
        thumbs.forEach((thumb, i) => {
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      };

      const ir = (i) => {
        index = (i + thumbs.length) % thumbs.length;
        frame.scrollTo({ left: frame.clientWidth * index });
        mark();
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => ir(i)));
      root.querySelectorAll('[data-mag-hero-prev]').forEach((el) => el.addEventListener('click', () => ir(index - 1)));
      root.querySelectorAll('[data-mag-hero-next]').forEach((el) => el.addEventListener('click', () => ir(index + 1)));

      // Al arrastrar manda el gesto: se lee la posición y se marca la miniatura
      // que toca, sin volver a mover el carril.
      frame.addEventListener(
        'scroll',
        () => {
          if (!frame.clientWidth) return;
          const next = Math.round(frame.scrollLeft / frame.clientWidth);
          if (next !== index) {
            index = next;
            mark();
          }
        },
        { passive: true }
      );
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mag-ingredients"] && !Shopify.designMode) return;
  try {
    
  // Tab switcher for `c-mag-ingredients`. Bundled globally, so it scopes itself
  // to its own sections and re-inits when the theme editor reloads one.
  (() => {
    const SELECTOR = '[data-section-type="c-mag-ingredients"]';

    function init(root) {
      if (!root || root.dataset.magIngReady === '1') return;
      root.dataset.magIngReady = '1';

      const tabs = [...root.querySelectorAll('[data-mag-tab]')];
      const cards = [...root.querySelectorAll('[data-mag-card]')];
      if (!tabs.length) return;

      const select = (id) => {
        tabs.forEach((tab) => {
          tab.setAttribute('aria-selected', tab.dataset.magTab === id ? 'true' : 'false');
        });
        cards.forEach((card) => {
          // A card with no tab (or one pointing at a deleted tab) shows always.
          card.hidden = Boolean(card.dataset.magCard) && card.dataset.magCard !== id;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => select(tab.dataset.magTab));
      });
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mag-product"] && !Shopify.designMode) return;
  try {
    
  // Gallery + quantity stepper for `c-mag-product`.
  //
  // Section javascript blocks are bundled into ONE file that loads on every
  // page, so this must find its own sections rather than assume it owns the
  // document. It also has to survive the theme editor swapping a section in and
  // out, hence the `shopify:section:load` re-init.
  (() => {
    const SELECTOR = '[data-section-type="c-mag-product"]';

    function init(root) {
      if (!root || root.dataset.magReady === '1') return;
      root.dataset.magReady = '1';

      const gallery = root.querySelector('[data-mag-gallery]');
      if (gallery) {
        const frame = gallery.querySelector('[data-mag-frame]');
        const slides = [...gallery.querySelectorAll('[data-mag-slide]')];
        const thumbs = [...gallery.querySelectorAll('[data-mag-thumb]')];
        let index = 0;

        // Sólo marca; mover el carril es cosa aparte para que el arrastre del
        // dedo no se pelee con el scroll programado.
        const mark = () => {
          thumbs.forEach((thumb, i) => {
            thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
          const active = thumbs[index];
          if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        };

        const show = (next) => {
          if (!slides.length || !frame) return;
          index = (next + slides.length) % slides.length;
          frame.scrollTo({ left: frame.clientWidth * index });
          mark();
        };

        gallery.querySelectorAll('[data-mag-prev]').forEach((el) => {
          el.addEventListener('click', () => show(index - 1));
        });
        gallery.querySelectorAll('[data-mag-next]').forEach((el) => {
          el.addEventListener('click', () => show(index + 1));
        });
        thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => show(i));
        });

        if (frame) {
          frame.addEventListener(
            'scroll',
            () => {
              if (!frame.clientWidth) return;
              const next = Math.round(frame.scrollLeft / frame.clientWidth);
              if (next !== index) {
                index = next;
                mark();
              }
            },
            { passive: true }
          );
        }
      }

      const qtyInput = root.querySelector('[data-mag-qty-input]');
      if (qtyInput) {
        root.querySelectorAll('[data-mag-qty]').forEach((button) => {
          button.addEventListener('click', () => {
            const step = Number(button.dataset.magQty) || 0;
            const next = Math.max(1, (Number(qtyInput.value) || 1) + step);
            qtyInput.value = String(next);
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-multiproduct-information"] && !Shopify.designMode) return;
  try {
    
  // Plan tabs, flavour swatches and purchase-type sync for
  // `c-multiproduct-information`. Section JS is bundled for every page, so it
  // finds its own sections and re-inits on `shopify:section:load`.
  (() => {
    const SELECTOR = '[data-section-type="c-multiproduct-information"]';

    function visibleVariant(panel) {
      return panel.querySelector('.c-mpi__variant:not([hidden])');
    }

    // Copy the checked purchase row into the plan's form. A plan row's qty is
    // its months per shipment, as in c-product-tabs; one-time is 1.
    function syncPanel(panel) {
      const form = panel.querySelector('[data-mpi-form]');
      const block = visibleVariant(panel);
      if (!form || !block) return;
      const checked = block.querySelector('[data-mpi-purchase]:checked');
      if (!checked) return;

      const idInput = form.querySelector('[data-mpi-id-input]');
      const planInput = form.querySelector('[data-mpi-plan-input]');
      const qtyInput = form.querySelector('[data-mpi-qty-input]');
      const planId = checked.dataset.planId;

      if (idInput) idInput.value = checked.dataset.variantId;
      if (qtyInput) qtyInput.value = planId ? Math.max(1, parseInt(checked.dataset.qty, 10) || 1) : 1;
      if (planInput) {
        planInput.value = planId || '';
        planInput.disabled = !planId;
      }

      const price = block.querySelector('[data-mpi-price]');
      if (price && checked.dataset.display) price.textContent = checked.dataset.display;
    }

    function init(root) {
      if (!root || root.dataset.mpiReady === '1') return;
      root.dataset.mpiReady = '1';

      const tablist = root.querySelector('[data-mpi-tablist]');
      const tabs = tablist ? [...tablist.querySelectorAll('[data-mpi-tab]')] : [];

      const activate = (tab, { focus } = {}) => {
        const id = tab.dataset.mpiTab;
        tabs.forEach((el) => {
          const on = el === tab;
          el.setAttribute('aria-selected', on ? 'true' : 'false');
          el.setAttribute('tabindex', on ? '0' : '-1');
        });
        root.querySelectorAll('[data-mpi-plan]').forEach((el) => {
          el.hidden = el.dataset.mpiPlan !== id;
        });
        if (focus) tab.focus();
      };

      // ── Deep links: #c-mpi-<key> (from c-plan-cards or any link) ──
      // Opens the matching tab and scrolls the section to just under the
      // sticky header. Done here, not by the browser's anchor jump, because
      // there is no element with that id: the hash names a plan, not a node.
      const headerOffset = () => {
        let el = document.elementFromPoint(window.innerWidth / 2, 1);
        while (el && el !== document.body) {
          const pos = getComputedStyle(el).position;
          if (pos === 'sticky' || pos === 'fixed') return Math.max(0, el.getBoundingClientRect().bottom);
          el = el.parentElement;
        }
        return 0;
      };

      const openFromHash = (hash) => {
        const m = /^#c-mpi-(.+)$/.exec(hash || '');
        if (!m) return false;
        const key = decodeURIComponent(m[1]);
        const tab = tabs.find((el) => el.dataset.mpiKey === key);
        if (!tab) return false;
        activate(tab);
        return true;
      };

      const scrollToSection = (smooth) => {
        const top = root.getBoundingClientRect().top + window.scrollY - headerOffset();
        window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
      };

      if (openFromHash(window.location.hash)) {
        if (document.readyState === 'complete') scrollToSection(false);
        else window.addEventListener('load', () => scrollToSection(false), { once: true });
      }

      document.addEventListener('click', (event) => {
        const link = event.target.closest && event.target.closest('a[href*="#c-mpi-"]');
        if (!link || link.pathname !== window.location.pathname) return;
        if (!openFromHash(link.hash)) return;
        event.preventDefault();
        history.replaceState(null, '', link.hash);
        scrollToSection(true);
        const active = tabs.find((el) => el.getAttribute('aria-selected') === 'true');
        if (active) active.focus({ preventScroll: true });
      });

      if (tablist) {
        tablist.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-mpi-tab]');
          if (tab) activate(tab);
        });

        // Automatic activation (WAI-ARIA APG tabs): arrows move and select.
        tablist.addEventListener('keydown', (event) => {
          const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          const current = tabs.indexOf(event.target.closest('[data-mpi-tab]'));
          if (current === -1) return;
          event.preventDefault();
          let next = current;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else {
            const delta = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
            next = (current + delta + tabs.length) % tabs.length;
          }
          activate(tabs[next], { focus: true });
        });
      }

      // Gallery images are lazy, and a hidden slide never starts loading, so
      // switching would flash an empty frame. Once the page has loaded, warm
      // the open plan's images; a plan's own are warmed the first time it is
      // used.
      const warm = (gallery) => {
        if (!gallery || gallery.dataset.mpiWarm === '1') return;
        gallery.dataset.mpiWarm = '1';
        gallery.querySelectorAll('.c-mpi__slide img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      };
      const warmOpen = () => warm(root.querySelector('[data-mpi-gallery]:not([hidden])'));
      if (document.readyState === 'complete') warmOpen();
      else window.addEventListener('load', warmOpen, { once: true });
      // After the tab handler has shown the new plan.
      root.querySelectorAll('[role="tab"]').forEach((tab) => tab.addEventListener('click', () => setTimeout(warmOpen)));

      // Gallery: one visible slide per plan; thumbnails pick it.
      const showSlide = (gallery, index) => {
        warm(gallery);
        gallery.querySelectorAll('[data-mpi-slide]').forEach((el) => {
          el.hidden = el.dataset.mpiSlide !== String(index);
        });
        const thumbs = gallery.querySelector('.c-mpi__thumbs');
        gallery.querySelectorAll('[data-mpi-thumb]').forEach((btn) => {
          const on = btn.dataset.mpiThumb === String(index);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          // Keep the active thumbnail in view without scrolling the page.
          if (on && thumbs && thumbs.scrollWidth > thumbs.clientWidth) {
            thumbs.scrollTo({ left: btn.offsetLeft - (thumbs.clientWidth - btn.offsetWidth) / 2, behavior: 'smooth' });
          }
        });
      };

      root.querySelectorAll('[data-mpi-gallery]').forEach((gallery) => {
        gallery.querySelectorAll('[data-mpi-thumb]').forEach((btn) => {
          btn.addEventListener('click', () => showSlide(gallery, btn.dataset.mpiThumb));
        });

        // Desktop arrows: previous / next image, wrapping at either end.
        gallery.querySelectorAll('[data-mpi-step]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const slides = [...gallery.querySelectorAll('[data-mpi-slide]')];
            const current = slides.findIndex((el) => !el.hidden);
            const next = (current + Number(btn.dataset.mpiStep) + slides.length) % slides.length;
            showSlide(gallery, slides[next].dataset.mpiSlide);
          });
        });
      });

      root.querySelectorAll('[data-mpi-panel]').forEach((panel) => {
        const planId = panel.dataset.mpiPlan;

        // Flavour: show that variant's rows for this plan only, and make
        // its image the active one in the gallery.
        panel.querySelectorAll('[data-mpi-swatch]').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            const variantId = radio.dataset.variantId;
            root.querySelectorAll('[data-mpi-plan="' + planId + '"] [data-mpi-variant]').forEach((el) => {
              el.hidden = el.dataset.mpiVariant !== variantId;
            });
            const gallery = root.querySelector('[data-mpi-gallery][data-mpi-plan="' + planId + '"]');
            const slide = gallery && [...gallery.querySelectorAll('[data-mpi-slide]')].find((el) =>
              (el.dataset.mpiSlideVariants || '').includes(' ' + variantId + ' ')
            );
            if (slide) showSlide(gallery, slide.dataset.mpiSlide);
            const value = panel.querySelector('[data-mpi-flavour-value]');
            if (value) value.textContent = radio.dataset.valueName || '';
            syncPanel(panel);
          });
        });

        panel.querySelectorAll('[data-mpi-purchase]').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (radio.checked) syncPanel(panel);
          });
        });

        // The markup pre-checks a row, but the form starts as a one-time
        // purchase; sync now so an untouched "Add to cart" buys what is shown.
        syncPanel(panel);
      });
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });

    // Theme editor: selecting a Plan block opens its tab.
    document.addEventListener('shopify:block:select', (event) => {
      const tab = event.target && event.target.closest && event.target.closest('[data-mpi-tab]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-plan-cards"] && !Shopify.designMode) return;
  try {
    
  // Mobile rail for `c-plan-cards`: open centred on the chosen card. The
  // card links themselves need no JS here; c-multiproduct-information
  // handles the `#c-mpi-<key>` hash.
  (() => {
    const SELECTOR = '[data-section-type="c-plan-cards"]';

    function init(root) {
      if (!root || root.dataset.pcReady === '1') return;
      root.dataset.pcReady = '1';
      const rail = root.querySelector('[data-pc-rail]');
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      const item = rail.children[parseInt(rail.dataset.pcStart, 10) || 0];
      if (!item) return;
      rail.scrollLeft = item.offsetLeft - (rail.clientWidth - item.offsetWidth) / 2;
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-problem"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProblemSwiper(sectionEl) {
      var swiperId = sectionEl.dataset.sectionId;
      var swiperEl = sectionEl.querySelector('#c-problem-swiper-' + swiperId);
      var paginationEl = sectionEl.querySelector('#c-problem-pagination-' + swiperId);
      if (!swiperEl || !paginationEl) return;

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      var sections = document.querySelectorAll('[data-section-type="c-problem"]');
      sections.forEach(initProblemSwiper);
    });

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-section-type="c-problem"]');
      if (section) initProblemSwiper(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product-tabs"] && !Shopify.designMode) return;
  try {
    
  // Tab switch, flavour swatch, and purchase-plan sync for `c-product-tabs`.
  // Bundled section JS runs on every page, so this finds its own sections
  // rather than assuming it owns the document, and re-inits on
  // `shopify:section:load` so the theme editor keeps working.
  (() => {
    const SELECTOR = '[data-section-type="c-product-tabs"]';

    function formatMoney(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    // `qty` is the plan's units per shipment (its months, from the row's
    // `data-qty`): a 3-month plan adds 3 so Recharge bills 3 × the monthly
    // price every 3 months, matching the subscription widget. One-time is 1.
    function syncForm(root, formSelector, variantId, planId, qty) {
      const form = root.querySelector(formSelector);
      if (!form) return;
      const idInput = form.querySelector('[data-pt-id-input]');
      const planInput = form.querySelector('[data-pt-plan-input]');
      const qtyInput = form.querySelector('[data-pt-qty-input]');
      if (idInput && variantId) idInput.value = variantId;
      if (qtyInput) qtyInput.value = planId ? Math.max(1, parseInt(qty, 10) || 1) : 1;
      if (planInput) {
        if (planId) {
          planInput.value = planId;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
    }

    // ── Gallery: same scroll-snap-frame + thumbnail-rail behavior for both
    // tabs' galleries, so this is written once and called per `[data-pt-gallery]`. ──
    function initGallery(gallery) {
      const frame = gallery.querySelector('[data-pt-frame]');
      // Selected by class, not a data attribute: `image_tag` only emits its own
      // documented attributes, so an arbitrary `data_pt_slide:` argument is
      // dropped without warning and this list silently came back empty — which
      // took the arrows and thumbnails down with it. Nothing reads a slide
      // index off the element anyway; the index comes from scroll position.
      const slides = frame ? [...frame.querySelectorAll('.c-pt__gallery-slide')] : [];
      const thumbs = [...gallery.querySelectorAll('[data-pt-thumb]')];
      let index = 0;

      const mark = () => {
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === index ? 'true' : 'false'));
        const active = thumbs[index];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };

      const show = (next) => {
        if (!slides.length || !frame) return;
        index = (next + slides.length) % slides.length;
        // Direct assignment rather than scrollTo(): it always lands, where
        // scrollTo() can be left pending (seen in a backgrounded tab).
        frame.scrollLeft = frame.clientWidth * index;
        mark();
      };

      // Hooks for the swatches (jump to a variant's image) and the tab
      // switcher (re-apply the position once a hidden panel has a width;
      // scrolling a `hidden` frame is a no-op because it measures 0 wide).
      gallery.ptShow = (i) => show(i);
      gallery.ptSync = () => show(index);

      const start = parseInt(gallery.dataset.ptStart, 10);
      if (start > 0 && start < slides.length) {
        index = start;
        mark();
        show(start);
      }

      gallery.querySelectorAll('[data-pt-prev]').forEach((el) => el.addEventListener('click', () => show(index - 1)));
      gallery.querySelectorAll('[data-pt-next]').forEach((el) => el.addEventListener('click', () => show(index + 1)));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));

      if (frame) {
        frame.addEventListener(
          'scroll',
          () => {
            if (!frame.clientWidth) return;
            const next = Math.round(frame.scrollLeft / frame.clientWidth);
            if (next !== index) {
              index = next;
              mark();
            }
          },
          { passive: true }
        );
      }
    }

    function initPlanRadios(root, panelSelector, formSelector, onChangeExtra) {
      const panel = root.querySelector(panelSelector);
      if (!panel) return;
      panel.querySelectorAll('.c-pt__plan-radio').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          syncForm(root, formSelector, radio.dataset.variantId, radio.dataset.planId, radio.dataset.qty);
          if (onChangeExtra) onChangeExtra(radio);
        });
      });
    }

    function init(root) {
      if (!root || root.dataset.ptReady === '1') return;
      root.dataset.ptReady = '1';

      // ── Tab switcher (real ARIA tabs; CSS already shows panel 1 by default) ──
      const tablist = root.querySelector('[data-pt-tablist]');
      if (tablist) {
        const tabs = [...tablist.querySelectorAll('[data-pt-tab]')];

        // Shared by click + keyboard activation — WAI-ARIA APG "automatic
        // activation" Tabs pattern: moving focus to a tab also selects it.
        // Also drives roving tabindex so Tab only stops on the active tab.
        const activateTab = (btn, { focus } = {}) => {
          const which = btn.getAttribute('data-pt-tab');

          root.setAttribute('data-active-tab', which);
          tabs.forEach((el) => {
            const isActive = el === btn;
            el.setAttribute('aria-selected', isActive ? 'true' : 'false');
            el.setAttribute('tabindex', isActive ? '0' : '-1');
          });
          root.querySelectorAll('[data-pt-panel]').forEach((panel) => {
            panel.hidden = panel.getAttribute('data-pt-panel') !== which;
            if (!panel.hidden) {
              panel.querySelectorAll('[data-pt-gallery]').forEach((g) => g.ptSync && g.ptSync());
            }
          });
          if (focus) btn.focus();
        };

        tablist.addEventListener('click', (event) => {
          const btn = event.target.closest('[data-pt-tab]');
          if (!btn || !tablist.contains(btn)) return;
          activateTab(btn);
        });

        // ArrowLeft/ArrowRight move focus to (and activate) the adjacent
        // tab, wrapping at the ends — Enter/Space need no handling since
        // these are native <button>s.
        tablist.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const currentIndex = tabs.indexOf(event.target.closest('[data-pt-tab]'));
          if (currentIndex === -1) return;

          event.preventDefault();
          const delta = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (currentIndex + delta + tabs.length) % tabs.length;
          activateTab(tabs[nextIndex], { focus: true });
        });

        // ── Deep links: #c-pt-tab-1 / #c-pt-tab-2 ──
        // Opens the named tab and scrolls the section to just under the sticky
        // header. The scroll is done here rather than by the browser's anchor
        // jump because the sections above this one keep changing height while
        // the page scrolls (lazy images, carousels setting up), which left the
        // native jump short of the section. After the first scroll the target
        // is re-measured for a moment and corrected if anything above it moved.
        const headerOffset = () => {
          // Whatever is stuck to the top of the viewport (the theme header) —
          // found by what sits at the top-centre pixel, not by class name.
          let el = document.elementFromPoint(window.innerWidth / 2, 1);
          while (el && el !== document.body) {
            const pos = getComputedStyle(el).position;
            if (pos === 'sticky' || pos === 'fixed') return Math.max(0, el.getBoundingClientRect().bottom);
            el = el.parentElement;
          }
          return 0;
        };
        const targetTop = () => root.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;

        let settleTimer = null;
        const scrollToSection = (smooth) => {
          window.scrollTo({ top: targetTop(), behavior: smooth ? 'smooth' : 'auto' });
          // Re-check for 1.5s: once the scroll is done, nudge to the section if
          // the layout above it has shifted since.
          clearInterval(settleTimer);
          let checks = 0;
          let lastY = -1;
          settleTimer = setInterval(() => {
            checks += 1;
            const moving = Math.abs(window.scrollY - lastY) > 1;
            lastY = window.scrollY;
            if (!moving && Math.abs(targetTop() - window.scrollY) > 2) {
              window.scrollTo({ top: targetTop(), behavior: 'auto' });
            }
            if (checks >= 15) clearInterval(settleTimer);
          }, 100);
        };

        // The visitor takes over the moment they scroll themselves.
        ['wheel', 'touchstart', 'keydown'].forEach((type) => {
          window.addEventListener(type, () => clearInterval(settleTimer), { passive: true });
        });

        const openFromHash = (hash) => {
          const m = /^#c-pt-tab-(\d+)$/.exec(hash || '');
          if (!m) return false;
          const btn = tabs.find((el) => el.getAttribute('data-pt-tab') === m[1]);
          if (!btn) return false;
          activateTab(btn);
          return true;
        };

        // Arriving with the hash in the URL (from another page): open the tab
        // and land on the section once the page has laid out.
        if (openFromHash(window.location.hash)) {
          if (document.readyState === 'complete') scrollToSection(false);
          else window.addEventListener('load', () => scrollToSection(false), { once: true });
        }

        // A link on this page: take over from the browser's jump.
        document.addEventListener('click', (event) => {
          const link = event.target.closest('a[href*="#c-pt-tab-"]');
          if (!link || link.pathname !== window.location.pathname) return;
          if (!openFromHash(link.hash)) return;
          event.preventDefault();
          history.replaceState(null, '', link.hash);
          scrollToSection(true);
        });
      }

      // ── Galleries ──
      root.querySelectorAll('[data-pt-gallery]').forEach(initGallery);

      // ── Flavour swatches, both tabs ──
      // Each tab keeps its own active-variant attribute and its own block
      // selector; a radio declares which tab it belongs to via
      // `data-pt-swatch-tab` (absent means tab 1, the original markup).
      const swatchRadios = root.querySelectorAll('[data-pt-swatch]');
      swatchRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;

          const tab = radio.dataset.ptSwatchTab === '2' ? '2' : '1';
          const attr = tab === '2' ? 'data-active-variant-2' : 'data-active-variant';
          const blockAttr = tab === '2' ? 'data-pt-variant-block-2' : 'data-pt-variant-block';
          const labelSel = tab === '2' ? '[data-pt-flavour-value-2]' : '[data-pt-flavour-value]';
          const formSel = '[data-pt-form="' + tab + '"]';

          const variantId = radio.dataset.variantId;
          root.setAttribute(attr, variantId);

          const valueLabel = root.querySelector(labelSel);
          if (valueLabel) valueLabel.textContent = radio.dataset.valueName || '';

          // Show the selected variant's own image in this tab's gallery.
          const mediaIndex = parseInt(radio.dataset.mediaIndex, 10);
          const gallery = root.querySelector('[data-pt-panel="' + tab + '"] [data-pt-gallery]');
          if (gallery && gallery.ptShow && !Number.isNaN(mediaIndex)) gallery.ptShow(mediaIndex);

          // The newly visible variant block may have a different checked
          // plan radio than the one that was active before — resync the
          // form to whatever is actually checked in that block right now.
          const block = root.querySelector('[' + blockAttr + '="' + variantId + '"]');
          const checkedPlan = block ? block.querySelector('.c-pt__plan-radio:checked') : null;
          if (checkedPlan) {
            syncForm(root, formSel, checkedPlan.dataset.variantId, checkedPlan.dataset.planId, checkedPlan.dataset.qty);
          } else {
            syncForm(root, formSel, variantId, '', 1);
          }

          // Tab 2's CTA carries a live price token; keep it truthful when the
          // variant changes, not just when a plan radio does.
          if (tab === '2') {
            const cta = root.querySelector('[data-pt-cta-2]');
            const priceCents = checkedPlan ? parseInt(checkedPlan.dataset.monthCents || checkedPlan.dataset.priceCents, 10) : NaN;
            if (cta && !Number.isNaN(priceCents)) {
              cta.textContent = cta.textContent.replace(/£[\d.,]+/, formatMoney(priceCents));
            }
          }
        });
      });

      // ── Initial form state ──
      // A plan row is pre-checked in the markup, but the forms render with no
      // selling plan and quantity 1. Sync each tab's form from the checked row
      // in the block for its current variant, so "Add to cart" without
      // touching anything buys what the page shows as selected.
      [['1', 'data-pt-variant-block'], ['2', 'data-pt-variant-block-2']].forEach(([tab, blockAttr]) => {
        const formSel = '[data-pt-form="' + tab + '"]';
        const form = root.querySelector(formSel);
        const idInput = form ? form.querySelector('[data-pt-id-input]') : null;
        if (!idInput) return;
        const block = root.querySelector('[' + blockAttr + '="' + idInput.value + '"]');
        const checked = block ? block.querySelector('.c-pt__plan-radio:checked') : null;
        if (checked) syncForm(root, formSel, checked.dataset.variantId, checked.dataset.planId, checked.dataset.qty);
      });

      // ── Tab 1 purchase-plan rows: keep the standalone form in sync ──
      initPlanRadios(root, '[data-pt-panel="1"]', '[data-pt-form="1"]');

      // ── Tab 2 purchase-plan rows: sync form AND live-update the CTA price token ──
      initPlanRadios(root, '[data-pt-panel="2"]', '[data-pt-form="2"]', (radio) => {
        const cta = root.querySelector('[data-pt-cta-2]');
        if (!cta) return;
        const priceStr = formatMoney(parseInt(radio.dataset.monthCents || radio.dataset.priceCents, 10) || 0);
        cta.textContent = cta.textContent.replace(/£[\d.,]+/, priceStr);
      });
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sl-id="sl-section-steps-v1"]').forEach(function (section) {
      var list = section.querySelector('.c-steps__list');
      var prevBtn = section.querySelector('[data-steps-prev]');
      var nextBtn = section.querySelector('[data-steps-next]');
      if (!list || !prevBtn || !nextBtn) return;

      function getStepWidth() {
        var step = list.querySelector('.c-steps__step');
        return step ? step.offsetWidth : 0;
      }

      prevBtn.addEventListener('click', function () {
        list.scrollBy({ left: -getStepWidth(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        list.scrollBy({ left: getStepWidth(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-ugc-v3"] && !Shopify.designMode) return;
  try {
    
  // Rail, dots and video wiring for `c-ugc-v3`. Section JS is bundled for
  // every page, so it finds its own sections and re-inits on section:load.
  (() => {
    const SELECTOR = '[data-section-type="c-ugc-v3"]';

    function initVideos(root) {
      const cards = [...root.querySelectorAll('[data-u3-card]')];

      // Muted preview only while a card is on screen; nothing loads or plays
      // off screen (the videos are preload="none").
      const io = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const card = entry.target;
              const video = card.querySelector('video');
              if (!video || card.classList.contains('is-playing')) return;
              if (entry.isIntersecting) video.play().catch(() => {});
              else video.pause();
            });
          }, { threshold: 0.5 })
        : null;

      cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        const play = card.querySelector('[data-u3-play]');
        const mute = card.querySelector('[data-u3-mute]');
        const on = mute && mute.querySelector('[data-u3-unmuted]');
        const off = mute && mute.querySelector('[data-u3-muted]');

        const syncMute = () => {
          if (on) on.style.display = video.muted ? 'none' : '';
          if (off) off.style.display = video.muted ? '' : 'none';
        };

        const stop = () => {
          video.muted = true;
          card.classList.remove('is-playing');
          syncMute();
        };

        if (io) io.observe(card);

        if (play) {
          play.addEventListener('click', (event) => {
            event.stopPropagation();
            // One playing with sound at a time.
            cards.forEach((other) => {
              if (other !== card && other.classList.contains('is-playing')) {
                const v = other.querySelector('video');
                if (v) v.muted = true;
                other.classList.remove('is-playing');
              }
            });
            video.muted = false;
            video.currentTime = 0;
            video.play().catch(() => {});
            card.classList.add('is-playing');
            syncMute();
          });
        }

        card.addEventListener('click', () => {
          if (card.classList.contains('is-playing')) stop();
        });

        if (mute) {
          mute.addEventListener('click', (event) => {
            event.stopPropagation();
            video.muted = !video.muted;
            syncMute();
          });
        }
      });
    }

    function initRail(root) {
      const rail = root.querySelector('[data-u3-rail]');
      if (!rail) return;
      const items = [...rail.querySelectorAll('[data-u3-item]')];
      const dots = [...root.querySelectorAll('[data-u3-dot]')];
      const prev = root.querySelector('[data-u3-prev]');
      const next = root.querySelector('[data-u3-next]');

      // The active card is the one whose start is nearest the rail's start.
      const activeIndex = () => {
        const left = rail.getBoundingClientRect().left;
        let best = 0;
        let bestDist = Infinity;
        items.forEach((item, i) => {
          const d = Math.abs(item.getBoundingClientRect().left - left);
          if (d < bestDist) {
            bestDist = d;
            best = i;
          }
        });
        return best;
      };

      const atEnd = () => rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;

      // On wide screens the last few cards can never reach the rail's start,
      // so once the rail is scrolled to the end the last dot is the active one.
      const update = () => {
        const index = atEnd() ? items.length - 1 : activeIndex();
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
        if (prev) prev.disabled = rail.scrollLeft <= 1;
        if (next) next.disabled = atEnd();
      };

      const goTo = (i) => {
        const item = items[Math.max(0, Math.min(items.length - 1, i))];
        if (!item) return;
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      };

      let ticking = false;
      rail.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      }, { passive: true });

      // Nearest card start before / after the rail's real position, so one
      // press is one card even at the end, where the last cards cannot
      // reach the rail's start (same rule as c-ingredients-v2).
      const stepTo = (dir) => {
        const pos = rail.scrollLeft;
        const starts = items.map((item) => item.offsetLeft - rail.offsetLeft);
        let target = dir < 0 ? -1 : items.length;
        starts.forEach((start, i) => {
          if (dir < 0 && start < pos - 1) target = i;
          if (dir > 0 && start > pos + 1 && target === items.length) target = i;
        });
        goTo(target);
      };
      if (prev) prev.addEventListener('click', () => stepTo(-1));
      if (next) next.addEventListener('click', () => stepTo(1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    function init(root) {
      if (!root || root.dataset.u3Ready === '1') return;
      root.dataset.u3Ready = '1';
      initRail(root);
      initVideos(root);
    }

    const boot = () => document.querySelectorAll(SELECTOR).forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) init(target);
      else if (target) target.querySelectorAll?.(SELECTOR).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
